(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5884],{

/***/ 73763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ benefits_Benefits; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./components/careers/benefits/Benefits.module.scss
var Benefits_module = __webpack_require__(35001);
var Benefits_module_default = /*#__PURE__*/__webpack_require__.n(Benefits_module);
;// CONCATENATED MODULE: ../core/dist/icons/Salary.svg
var _text;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgSalary(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), _text || (_text = /*#__PURE__*/react.createElement("text", {
    "data-name": "\\uD83D\\uDCB0",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/react.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83D\uDCB0"))));
}

/* harmony default export */ var Salary = (SvgSalary);
;// CONCATENATED MODULE: ../core/dist/icons/Party.svg
var Party_text;

function Party_extends() { Party_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Party_extends.apply(this, arguments); }



function SvgParty(props) {
  return /*#__PURE__*/react.createElement("svg", Party_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), Party_text || (Party_text = /*#__PURE__*/react.createElement("text", {
    "data-name": "\\uD83C\\uDF7E",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/react.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83C\uDF7E"))));
}

/* harmony default export */ var Party = (SvgParty);
;// CONCATENATED MODULE: ../core/dist/icons/healthyWorkLife.svg
var healthyWorkLife_text;

function healthyWorkLife_extends() { healthyWorkLife_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return healthyWorkLife_extends.apply(this, arguments); }



function SvgHealthyWorkLife(props) {
  return /*#__PURE__*/react.createElement("svg", healthyWorkLife_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), healthyWorkLife_text || (healthyWorkLife_text = /*#__PURE__*/react.createElement("text", {
    "data-name": "\\uD83E\\uDD29",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/react.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83E\uDD29"))));
}

/* harmony default export */ var healthyWorkLife = (SvgHealthyWorkLife);
;// CONCATENATED MODULE: ../core/dist/icons/System.svg
var System_text;

function System_extends() { System_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return System_extends.apply(this, arguments); }



function SvgSystem(props) {
  return /*#__PURE__*/react.createElement("svg", System_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), System_text || (System_text = /*#__PURE__*/react.createElement("text", {
    "data-name": "\\uD83D\\uDC69\\u200D\\uD83D\\uDCBB",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/react.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83D\uDC69\u200D\uD83D\uDCBB"))));
}

/* harmony default export */ var System = (SvgSystem);
;// CONCATENATED MODULE: ../core/dist/icons/Retreats.svg
var Retreats_text;

function Retreats_extends() { Retreats_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Retreats_extends.apply(this, arguments); }



function SvgRetreats(props) {
  return /*#__PURE__*/react.createElement("svg", Retreats_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), Retreats_text || (Retreats_text = /*#__PURE__*/react.createElement("text", {
    "data-name": "\\uD83C\\uDFD6",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/react.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83C\uDFD6"))));
}

/* harmony default export */ var Retreats = (SvgRetreats);
;// CONCATENATED MODULE: ../core/dist/icons/Pantry.svg
var Pantry_text;

function Pantry_extends() { Pantry_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Pantry_extends.apply(this, arguments); }



function SvgPantry(props) {
  return /*#__PURE__*/react.createElement("svg", Pantry_extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 66,
    viewBox: "0 0 51 66"
  }, props), Pantry_text || (Pantry_text = /*#__PURE__*/react.createElement("text", {
    "data-name": "\\uD83C\\uDF5F",
    transform: "translate(0 50)",
    fill: "#202124",
    fontSize: 50,
    fontFamily: "AppleColorEmoji, Apple Color Emoji",
    letterSpacing: "0em"
  }, /*#__PURE__*/react.createElement("tspan", {
    x: 0,
    y: 0
  }, "\uD83C\uDF5F"))));
}

/* harmony default export */ var Pantry = (SvgPantry);
;// CONCATENATED MODULE: ./components/careers/benefits/Benefits.tsx










var Benefits = function() {
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Benefits_module_default()).heading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                        children: [
                            "Let’s take a look at what’s in",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                "data-hover": "store for you",
                                className: isMobile ? "" : "indaiText",
                                children: "store for you"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "(Aside from the bundles of fun)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Benefits_module_default()).benefitsRow,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).benefitCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Benefits_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Benefits_module_default()).iconBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Salary, {
                                        width: "51",
                                        height: "66"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Competitive Salary"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "There is no “right” salary for the right person! Our salaries are mad-competitive."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).benefitCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Benefits_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Benefits_module_default()).iconBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Pantry, {
                                        width: "51",
                                        height: "66"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Stacked Pantry"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Fancy a snack, or two? Our pantry’s always loaded with tasty tidbits."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).benefitCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Benefits_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Benefits_module_default()).iconBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(healthyWorkLife, {
                                        width: "51",
                                        height: "66"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Healthy work-life Balance"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Think flexible work hours and generous leave policies."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).benefitCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Benefits_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Benefits_module_default()).iconBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(System, {
                                        width: "51",
                                        height: "66"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Tech of your Choice"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Mac-book or Windows? Pick any tech that you are comfortable with!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).benefitCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Benefits_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Benefits_module_default()).iconBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Retreats, {
                                        width: "51",
                                        height: "66"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Team Retreats"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We escape work stress with frequent getaways!"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Benefits_module_default()).benefitCol,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Benefits_module_default()).textBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Benefits_module_default()).iconBox,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Party, {
                                        width: "51",
                                        height: "66"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                    children: "Partying Hard"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Expect food escapades, team retreats and (lots of) booze!”"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var benefits_Benefits = (Benefits);


/***/ }),

/***/ 90385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Af": function() { return /* binding */ getCareersHomePageLayout; },
/* harmony export */   "zp": function() { return /* binding */ getCareersJobPostPageLayout; }
/* harmony export */ });
/* unused harmony exports MAX_JOBS_PER_PAGE, REVALIDATE_TIME, getCareerHomePageStaticProps, getCareerJobPostStaticProps, getCareerJobPostStaticPaths */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _vahak_core_dist_services_careers_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66727);
/* harmony import */ var components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62307);






var MAX_JOBS_PER_PAGE = 6;
var REVALIDATE_TIME = 7 * 24 * 60 * 60; // 7 days
/***
 * Careers Home Page Methods
 */ var getCareerHomePageStaticProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.t0 = _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z;
                    _ctx.t1 = _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z;
                    _ctx.t2 = {};
                    _ctx.next = 5;
                    return _vahak_core_dist_services_careers_service__WEBPACK_IMPORTED_MODULE_1__/* .CareersService.getAllJobs */ .l.getAllJobs({
                        page: 1,
                        limit: MAX_JOBS_PER_PAGE
                    });
                case 5:
                    _ctx.t3 = _ctx.sent;
                    _ctx.next = 8;
                    return _vahak_core_dist_services_careers_service__WEBPACK_IMPORTED_MODULE_1__/* .CareersService.getAllCategories */ .l.getAllCategories();
                case 8:
                    _ctx.t4 = _ctx.sent;
                    _ctx.t5 = (0, _ctx.t1)(_ctx.t2, _ctx.t3, _ctx.t4);
                    _ctx.t6 = {
                        revalidate: REVALIDATE_TIME
                    };
                    return _ctx.abrupt("return", (0, _ctx.t0)(_ctx.t5, _ctx.t6));
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCareerHomePageStaticProps() {
        return _ref.apply(this, arguments);
    };
}();
var getCareersHomePageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultTopLayout */ .E;
/***
 * Careers Job Post Page Methods
 */ var getCareerJobPostStaticProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(slug) {
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _vahak_core_dist_services_careers_service__WEBPACK_IMPORTED_MODULE_1__/* .CareersService.getJobBySlug */ .l.getJobBySlug({
                        slug: slug
                    });
                case 2:
                    _ctx.t0 = _ctx.sent;
                    _ctx.t1 = slug;
                    _ctx.t2 = REVALIDATE_TIME;
                    return _ctx.abrupt("return", {
                        data: _ctx.t0,
                        slug: _ctx.t1,
                        revalidate: _ctx.t2
                    });
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCareerJobPostStaticProps(slug) {
        return _ref.apply(this, arguments);
    };
}();
var getCareersJobPostPageLayout = components_layout_layout_methods__WEBPACK_IMPORTED_MODULE_2__/* .useDefaultTopLayout */ .E;
var getCareerJobPostStaticPaths = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var meta, jobs, paths;
        return _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _vahak_core_dist_services_careers_service__WEBPACK_IMPORTED_MODULE_1__/* .CareersService.getAllJobs */ .l.getAllJobs({
                        page: 1
                    });
                case 2:
                    meta = _ctx.sent.meta;
                    _ctx.next = 5;
                    return _vahak_core_dist_services_careers_service__WEBPACK_IMPORTED_MODULE_1__/* .CareersService.getAllJobs */ .l.getAllJobs({
                        page: 1,
                        limit: meta === null || meta === void 0 ? void 0 : meta.pagination.total
                    });
                case 5:
                    jobs = _ctx.sent.jobs;
                    paths = jobs === null || jobs === void 0 ? void 0 : jobs.reduce(function(paths, post) {
                        var tempObj = {};
                        tempObj["params"] = {
                            jobPost: post.slug
                        };
                        paths.push(tempObj);
                        return paths;
                    }, []);
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: "blocking"
                    });
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getCareerJobPostStaticPaths() {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 34113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ getJobMetaInfo; }
/* harmony export */ });
/* unused harmony export navToSection */
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_packages_nextjs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);


function getJobMetaInfo(str) {
    var ref, ref1, ref2;
    var fields = str === null || str === void 0 ? void 0 : str.split(";");
    var metaInfo = {};
    metaInfo["qualification"] = (ref = fields === null || fields === void 0 ? void 0 : fields.find(function(f) {
        return f.match("qualification");
    })) === null || ref === void 0 ? void 0 : ref.split("=")[1];
    metaInfo["experience"] = (ref1 = fields === null || fields === void 0 ? void 0 : fields.find(function(f) {
        return f.match("experience");
    })) === null || ref1 === void 0 ? void 0 : ref1.split("=")[1];
    metaInfo["type"] = (ref2 = fields === null || fields === void 0 ? void 0 : fields.find(function(f) {
        return f.match("type");
    })) === null || ref2 === void 0 ? void 0 : ref2.split("=")[1];
    return metaInfo;
}
var x = function(id) {
    var section = document.querySelector("#".concat(id));
    if (section) {
        section.scrollIntoView();
        window.scrollBy(0, -74);
        return;
    } else {
        setTimeout(function() {
            x(id);
        }, 1);
    }
};
function navToSection(id, router) {
    return _navToSection.apply(this, arguments);
}
function _navToSection() {
    _navToSection = _async_to_generator(regeneratorRuntime.mark(function _callee(id, router) {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    // router.push("/careers");
                    x(id);
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    // await sleep(200);
    // document.querySelector(`#${id}`)?.scrollIntoView();
    // window.scrollBy(0, -+getHeightByViewPort(74).slice(0, -2));
    }));
    return _navToSection.apply(this, arguments);
}


/***/ }),

/***/ 96696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83347);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61706);
/* harmony import */ var _vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28230);






var getCityMetaDescription = function(cityName) {
    return "Book ".concat(_vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__/* .PLATFORM_STATS.liveLoadsAndLorries.label */ .s.liveLoadsAndLorries.label, " loads and lorries in ").concat(cityName, "! Vahak is the #1 platform for ").concat(cityName, " transport services. Join India's largest transporter network today for free.");
};
/**
 * Registers page SEO with the global SeoProvider.
 * Rendering is handled by GlobalSeoHead in _app — route defaults live in methods/pageSeo.ts.
 */ var PageMetaTags = function(param) {
    var cityName = param.cityName, titleProp = param.title, descriptionProp = param.description, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, asPath = param.asPath, locale = param.locale, localeNeutralPath = param.localeNeutralPath, hreflangLocales = param.hreflangLocales, canonicalUrlProp = param.canonicalUrl, ogUrl = param.ogUrl, ogDescription = param.ogDescription, _ogImgSrc = param.ogImgSrc, ogImgSrc = _ogImgSrc === void 0 ? (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultOgImage */ .av)() : _ogImgSrc, ogImgAltTextProp = param.ogImgAltText, ogType = param.ogType, ogSiteName = param.ogSiteName, schema = param.schema, schemaOrgJsonUrlProp = param.schemaOrgJsonUrl, _includeDefaultSchema = param.includeDefaultSchema, includeDefaultSchema = _includeDefaultSchema === void 0 ? false : _includeDefaultSchema, _shouldBeIndexed = param.shouldBeIndexed, shouldBeIndexed = _shouldBeIndexed === void 0 ? true : _shouldBeIndexed, breadcrumbList = param.breadcrumbList, _schemaType = param.schemaType, schemaType = _schemaType === void 0 ? "WebPage" : _schemaType, faqList = param.faqList, children = param.children;
    var title = titleProp !== null && titleProp !== void 0 ? titleProp : cityName ? "Vahak - Book Best Transport Services in ".concat(cityName) : undefined;
    var description = descriptionProp !== null && descriptionProp !== void 0 ? descriptionProp : cityName ? getCityMetaDescription(cityName) : undefined;
    var canonicalUrl = canonicalUrlProp !== null && canonicalUrlProp !== void 0 ? canonicalUrlProp : cityName ? "https://www.vahak.in/city/".concat(cityName) : undefined;
    var schemaOrgJsonUrl = schemaOrgJsonUrlProp !== null && schemaOrgJsonUrlProp !== void 0 ? schemaOrgJsonUrlProp : cityName ? "/city/".concat(cityName) : undefined;
    var ogImgAltText = ogImgAltTextProp !== null && ogImgAltTextProp !== void 0 ? ogImgAltTextProp : description;
    var seoConfig = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            title: title,
            description: description,
            keywords: keywords,
            asPath: asPath,
            locale: locale,
            localeNeutralPath: localeNeutralPath,
            hreflangLocales: hreflangLocales,
            canonicalUrl: asPath ? undefined : canonicalUrl,
            ogUrl: ogUrl,
            ogDescription: ogDescription,
            ogImgSrc: ogImgSrc,
            ogImgAltText: ogImgAltText,
            ogType: ogType,
            ogSiteName: ogSiteName,
            schema: schema,
            schemaOrgJsonUrl: schemaOrgJsonUrl,
            includeDefaultSchema: includeDefaultSchema,
            shouldBeIndexed: shouldBeIndexed,
            breadcrumbList: breadcrumbList,
            schemaType: schemaType,
            faqList: faqList
        };
    }, [
        title,
        description,
        keywords,
        asPath,
        locale,
        localeNeutralPath,
        hreflangLocales,
        canonicalUrl,
        ogUrl,
        ogDescription,
        ogImgSrc,
        ogImgAltText,
        ogType,
        ogSiteName,
        schema,
        schemaOrgJsonUrl,
        includeDefaultSchema,
        shouldBeIndexed,
        breadcrumbList,
        schemaType,
        faqList
    ]);
    (0,_seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__/* .useRegisterPageSeo */ .C9)(seoConfig);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaTags);


/***/ }),

/***/ 62307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useDefaultTopLayout; }
/* harmony export */ });
/* unused harmony export useHomePageDefaultLayout */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99456);
/* harmony import */ var _default_layout_DefaultLayout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78485);
/* harmony import */ var _dashboard_navbar_DashboardNavbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51938);




var useDefaultTopLayout = function(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_1__/* .DefaultTopNavLayout */ .U1, {
        children: page
    });
};
var useHomePageDefaultLayout = function(page) {
    return /*#__PURE__*/ _jsx(DefaultLayout, {
        navContent: /*#__PURE__*/ _jsx(DashboardNav, {}),
        children: page
    });
};


/***/ }),

/***/ 38079:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"careersPageWrap":"Careers_careersPageWrap__UL8H_","sections":"Careers_sections__N97Ww","exploreJobSection":"Careers_exploreJobSection__aZ6lK","benefitsSection":"Careers_benefitsSection__f9j5S","jd":"Careers_jd__QAfO2","storiesSection":"Careers_storiesSection__0T_by"};

/***/ }),

/***/ 35001:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"Benefits_heading__yeuHv","benefitsRow":"Benefits_benefitsRow__OZlip","benefitCol":"Benefits_benefitCol__l6vjN","iconBox":"Benefits_iconBox__LKT_0","textBox":"Benefits_textBox__S70_o"};

/***/ })

}]);